import { compose } from 'recompose';

import PostDatedCheque from './PostDatedCheque';

import apiInterceptor from '../../../api/interceptor';

import { paymentApi } from '../../common/base.api';

const composedPostDatedCheque = compose(apiInterceptor({ ...paymentApi }))(PostDatedCheque);

export default composedPostDatedCheque;
